
































































import Vue from "vue";
import { MemberManagerService } from "@/common/api/services/MemberManagerService";
import Component from "vue-class-component";
import QErrors from "@/common/qErrors.vue";
import QNotify from "@/common/qNotify";
import { Prop } from "vue-property-decorator";
import { namespace } from "vuex-class";
import defineAbilityFor from "@/services/ability";

const auth = namespace("MemberAuth");

@Component({
  name: "RegisterLine",
  components: {
    QErrors,
  },
})
export default class RegisterLine extends Vue {
  @auth.Action
  updateToken!: (token: string) => void;
  @auth.Action
  fetchCurrentUser!: () => void;

  isShow = false;
  registerForm = {
    lineAccountId: "",
    email: "",
    password: "",
    nameMember: "",
  };
  errors = {};

  @Prop({ default: "" })
  lineAccountId;

  async submit() {
    let response;
    try {
      this.registerForm.lineAccountId = this.lineAccountId;
      response = await MemberManagerService.registerLine(this.registerForm);
    } catch (error: any) {
      response = error.body;
    }

    if (response.status == "error") {
      this.errors = response.errors;
      QNotify.error({
        text: response.message,
      });
      return;
    }

    QNotify.success({
      text: response.message,
    });

    localStorage.removeItem("line_account_id");

    // Save it to state
    this.updateToken(response.data.token);
    await this.fetchCurrentUser();

    // Set ability
    this.$ability.update(defineAbilityFor("member").rules);

    this.$router.push({ name: "mypage" });
    this.isShow = false;

    return;
  }

  show() {
    this.isShow = true;
    this.reset();
  }

  close() {
    this.isShow = false;
  }

  reset() {
    this.errors = {};
    this.registerForm = {
      lineAccountId: "",
      email: "",
      password: "",
      nameMember: "",
    };
  }
}
